export function chooseRecent(items, previous = [], random = Math.random) {
  const seen = new Set();
  const groups = new Map();
  for (const item of items) {
    if (!item.id || !item.image || seen.has(String(item.id))) continue;
    seen.add(String(item.id));
    const family = item.family || String(item.id);
    if (!groups.has(family)) groups.set(family, []);
    groups.get(family).push(item);
  }
  const shuffle = list => {
    const copy = [...list];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };
  const previousIds = new Set(previous.map(String));
  return shuffle([...groups.values()]).slice(0, 3).map(group => {
    const fresh = group.filter(item => !previousIds.has(String(item.id)));
    const options = fresh.length ? fresh : group;
    return options[Math.floor(random() * options.length)];
  });
}

function renderRecent(root) {
  let items;
  try { items = JSON.parse(root.querySelector('[data-recent-products]').textContent); }
  catch { return; }
  const key = 'sim-recent-products-v1';
  let previous = [];
  try { previous = JSON.parse(sessionStorage.getItem(key) || '[]'); }
  catch { previous = []; }
  if (!Array.isArray(previous)) previous = [];
  const selected = chooseRecent(items, previous);
  if (selected.length < 3) return;
  const fragment = document.createDocumentFragment();
  for (const product of selected) {
    const li = document.createElement('li');
    li.className = 'grid__item';
    li.dataset.productId = product.id;
    li.dataset.family = product.family;
    const card = document.createElement('article');
    card.className = 'sim-recent__card';
    const imageLink = document.createElement('a');
    imageLink.className = 'sim-recent__image';
    imageLink.href = product.url;
    imageLink.tabIndex = -1;
    imageLink.setAttribute('aria-hidden', 'true');
    const img = document.createElement('img');
    img.alt = product.alt;
    img.width = product.width;
    img.height = product.height;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.sizes = '(min-width: 1200px) 360px, (min-width: 750px) 30vw, 46vw';
    img.srcset = `${product.small} 360w, ${product.medium} 533w, ${product.image} 720w`;
    img.src = product.medium;
    imageLink.append(img);
    const info = document.createElement('div');
    info.className = 'sim-recent__info';
    const heading = document.createElement('h3');
    const titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    heading.append(titleLink);
    const price = document.createElement('p');
    price.className = 'sim-recent__price';
    if (product.compare) {
      const compare = document.createElement('s');
      compare.className = 'sim-recent__compare';
      compare.textContent = product.compare;
      price.append(compare);
    }
    const current = document.createElement('span');
    current.textContent = product.price;
    price.append(current);
    info.append(heading, price);
    card.append(imageLink, info);
    li.append(card);
    fragment.append(li);
  }
  root.querySelector('[data-recent-grid]').replaceChildren(fragment);
  try { sessionStorage.setItem(key, JSON.stringify(selected.map(item => String(item.id)))); }
  catch {}
}

if (typeof document !== 'undefined') {
  const setup = scope => {
    scope.querySelectorAll('[data-recent-showcase]').forEach(root => {
      if (root.dataset.recentReady) return;
      root.dataset.recentReady = 'true';
      if (!('IntersectionObserver' in window)) { renderRecent(root); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          renderRecent(root);
        }
      }, { rootMargin: '600px' });
      observer.observe(root);
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('[data-recent-showcase]').forEach(renderRecent);
  });
}
